import { z } from 'zod';

export const AddressSchema = z.object({
  country: z.string().optional(),
  postcode: z.string().optional(),
  fullAddress: z.string().optional(),
});

export type Address = z.infer<typeof AddressSchema>;
